import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface RiskMetric {
  token_symbol: string;
  sharpe_30d: number | null;
  sharpe_90d: number | null;
  sharpe_180d: number | null;
  sortino_90d: number | null;
  volatility_ann_90d: number | null;
  max_drawdown_90d: number | null;
  max_drawdown_180d: number | null;
  max_dd_peak_date: string | null;
  max_dd_trough_date: string | null;
  max_dd_recovery_days: number | null;
  current_drawdown_pct: number | null;
  data_points_used: number | null;
  calculated_at: string;
}

export function useRiskMetrics() {
  return useQuery({
    queryKey: ["risk-metrics"],
    queryFn: async (): Promise<Record<string, RiskMetric>> => {
      const { data, error } = await supabase
        .from("token_risk_metrics")
        .select("*");
      if (error) throw error;
      const map: Record<string, RiskMetric> = {};
      for (const row of (data ?? []) as RiskMetric[]) {
        map[row.token_symbol.toUpperCase()] = row;
      }
      return map;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useRiskMetric(symbol?: string) {
  const { data, ...rest } = useRiskMetrics();
  const metric = symbol && data ? data[symbol.toUpperCase()] : undefined;
  return { metric, ...rest };
}
